import {
  Grid,
  MetricItem,
  space,
} from "@waldner-laboreinrichtungen/component-system";
import type { FC } from "react";

import { getIncidentForChannel } from "../custom/common/function-grid-helpers.tsx";
import {
  formatValue,
  getExpectedValue,
  getIncidentBadgeProps,
  isChannelOutdated,
  isExternalChannel,
} from "../util/channel-data.tsx";
import type { ActiveProgram, Channel, Incident } from "../view-model.ts";
import { ExternTag } from "./extern-tag.tsx";

export type FunctionGridProps = {
  functions: Channel[];
  onSelect: (func: Channel) => void;
  unitState?: string;
  activeProgram?: ActiveProgram;
  incidents?: Incident[];
};

export const FunctionGrid: FC<FunctionGridProps> = ({
  functions,
  incidents,
  onSelect,
}) => (
  <Grid rowGap={space(3)}>
    {functions.map((channel, index) => {
      const incident = getIncidentForChannel(channel, incidents);
      const expected = getExpectedValue(channel);
      return (
        <Grid.Column key={channel ? channel.id : `empty-${index}`} width={3}>
          <div onClick={() => onSelect(channel)}>
            <MetricItem
              empty={!channel}
              expectedValue={expected}
              incidentState={incident?.severity}
              outdated={isChannelOutdated(channel)}
              tag={isExternalChannel(channel) ? <ExternTag /> : undefined}
              title={channel.name}
              value={formatValue(
                channel.current?.value,
                channel.unit,
                channel.name
              )}
              {...getIncidentBadgeProps(channel, incident)}
            />
          </div>
        </Grid.Column>
      );
    })}
  </Grid>
);
